import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
const _hoisted_1 = { key: 1 };
const _hoisted_2 = ["accept"];
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.image_uploads.upload_image_button')
};
const submitImage = () => {
    document.getElementById('imageUpload').click();
};
import { FILE_UPLOAD_CONSTANTS } from '@/constants';
import SvgIcon from '@/components/SvgIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'UploadImageButton',
    props: {
        loading: { type: Boolean }
    },
    emits: ['upload'],
    setup(__props, { emit }) {
        const allowedExtensions = FILE_UPLOAD_CONSTANTS.ALLOWED_EXTENSIONS;
        function handleUpload(event) {
            const image = event.target.files[0];
            emit('upload', image);
        }
        return (_ctx, _cache) => {
            const _component_PillButton = _resolveComponent("PillButton");
            return (_openBlock(), _createBlock(_component_PillButton, {
                kind: "secondary",
                disabled: __props.loading,
                onClick: submitImage
            }, {
                default: _withCtx(() => [
                    (__props.loading)
                        ? (_openBlock(), _createBlock(SvgIcon, {
                            key: 0,
                            name: "ellipsis",
                            class: "w-full h-8 dark:opacity-50"
                        }))
                        : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t('change_picture')), 1)),
                    _createElementVNode("input", {
                        id: "imageUpload",
                        class: "invisible hidden w-0 h-0",
                        multiple: "false",
                        tabindex: "0",
                        type: "file",
                        accept: _unref(allowedExtensions).join(),
                        onChange: handleUpload
                    }, null, 40, _hoisted_2)
                ], undefined, true),
                _: 1
            }, 8, ["disabled"]));
        };
    }
});
